import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch {
      toast.error("Erro ao processar solicitação");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-md p-8 animate-fade-up">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-xs text-[#475569] hover:text-[#001E50] mb-6">
          <ArrowLeft size={14} /> Voltar
        </Link>
        <h2 className="font-heading text-2xl font-semibold text-[#0F172A] mb-2">Esqueci minha senha</h2>
        <p className="text-sm text-[#475569] mb-6">Enviaremos um link de redefinição para o seu e-mail cadastrado.</p>

        {sent ? (
          <div className="p-4 bg-[#10B981]/10 border border-[#10B981]/30 rounded-md text-sm text-[#065F46]">
            Se o e-mail informado estiver cadastrado, um link foi enviado. Verifique sua caixa de entrada.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label>E-mail</Label>
              <Input
                data-testid="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="forgot-btn"
              disabled={loading}
              className="w-full h-11 bg-[#001E50] hover:bg-[#001740] text-white"
            >
              {loading ? "Enviando..." : "Enviar link de redefinição"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
